// generated from 104_407 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const emailFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("email_filter"),
  comparison_key: z.enum([
    "1", // 62_848 (60.20%)
    "17", // 14_553 (13.94%)
    "11", // 12_220 (11.70%)
    "10", // 9_114 (8.73%)
    "2", // 4_428 (4.24%)
    "12", // 1_244 (1.19%)
  ]),
  display_name: z.string(),
  // undefined: 38_374 (36.75%), defined 66_033 (63.25%)
  raw_value: z.string().optional(),
  value: z.string(),
  varies_by_app_group: z.literal(false),
});
